import { useState, useEffect } from 'react'
import './contact.css'
import details from"../dataStore/details.json"

export default function Contact(){

    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    const [submitCheck, setSubmitCheck] = useState(false)
    const [contactForm, setContactForm] = useState({
        name:"",
        email:"",
        message:""
    }) 
    const contactInput = (e) =>{
        const {name, value} = e.target;
        setContactForm((preDate)=>({
            ...preDate,
            [name]:value
        }))
    }

    const contactSubmit = async(e) =>{
        e.preventDefault()
        setSubmitCheck(true)

        const formData = new FormData(e.target);
        formData.append("access_key", process.env.REACT_APP_KEY);
        
        const response = await fetch(process.env.REACT_APP_LINK, {
            method: "POST",
            body: formData
        });
        
        const data = await response.json();
      
        if (data.success) {
            setSubmitCheck(false)
            setContactForm({
                name:"",
                email:"",
                message:""
            })
            alert(`Our Team will Contact you soon...
Feel free to call us...`)
        } else {
            console.log("Error", data);
            setSubmitCheck(false)
        }
        
    }
    return(
        <div className='wrapper'>
            <section className='contactContainer'>
                <h2>Feel <span>free </span>to <span>contact </span>with us</h2>
                <article>
                    <main>
                        <h3>Address</h3>
                        <p>{details.address}</p>
                        <figure>
                            <img src='./images/call_contact.svg' alt='call'/>
                            <p>{details.primary_phone} / {details.secondary_phone}</p>
                        </figure>
                        <figure>
                            <img src='./images/mail.png' alt='call'/>
                            <p>{details.mail}</p>
                        </figure>
                    </main>
                    <form onSubmit={contactSubmit}>
                        <h4>Send us a message</h4>
                        <div className='contactInput'>
                            <label>Name</label>
                            <input 
                                type='text'
                                name='name'
                                value={contactForm.name}
                                onChange={contactInput}
                                required
                            />
                        </div>
                        <div className='contactInput'>
                            <label>Email</label>
                            <input 
                                type='mail'
                                name='email'
                                value={contactForm.email}
                                onChange={contactInput}
                                required
                            />
                        </div>
                        <div className='contactInput'>
                            <label>Message</label>
                            <textarea 
                                name='message'
                                value={contactForm.message}
                                onChange={contactInput}
                                rows={3}
                                required
                            />
                        </div>
                        <div className='contactInput submitContact'>
                            <input 
                                type='submit'
                                value="Send" 
                                disabled={submitCheck}                               
                            />
                        </div>
                    </form>
                </article>
            </section>
        </div>
    )
}